import React from 'react';
import PropTypes from 'prop-types';

import { uiApplicationStatusTypes } from '../../../../constants/statusConstants';
import Invitation from './Invitation';

import ListingApplicationsApplicationSection from './ListingApplicationsApplicationSection';
import { calculateApplications, categorizeApplications } from '../../../../utils/listingApplicationListUtil';
import ArchivedApplicationsList from '../../../../components/ArchivedApplicationsList';

const { COMPLETED, IN_PROGRESS, INVITED } = uiApplicationStatusTypes;

export default function ListingApplications({ data, error, applicationEligibilitiesMap }) {
  const applications = calculateApplications(data);
  const { applicationMap, categorizedApplicationMap } = categorizeApplications(applications);

  return (
    <div className="ApplicationsList">
      <Invitation />
      {error ? null : (
        <>
          <ListingApplicationsApplicationSection
            key={COMPLETED.id}
            applications={categorizedApplicationMap[COMPLETED.id]}
            applicationMap={applicationMap}
            applicationEligibilitiesMap={applicationEligibilitiesMap}
            sectionType={COMPLETED}
          />
          <ListingApplicationsApplicationSection
            key={IN_PROGRESS.id}
            applications={categorizedApplicationMap[IN_PROGRESS.id]}
            applicationMap={applicationMap}
            applicationEligibilitiesMap={applicationEligibilitiesMap}
            sectionType={IN_PROGRESS}
          />
          <ListingApplicationsApplicationSection
            key={INVITED.id}
            applications={categorizedApplicationMap[INVITED.id]}
            applicationMap={applicationMap}
            applicationEligibilitiesMap={applicationEligibilitiesMap}
            sectionType={INVITED}
          />
          <ArchivedApplicationsList />
        </>
      )}
    </div>
  );
}

ListingApplications.propTypes = {
  data: PropTypes.object,
  error: PropTypes.any,
  applicationEligibilitiesMap: PropTypes.object,
};
